@import 'core';

/**
 * @prop --ads-button-background-color-primary: Primary background color
 * @prop --ads-button-background-color-primary-focus: Primary focused background color
 * @prop --ads-button-background-color-primary-hover: Primary hovered background color
 * @prop --ads-button-background-color-primary-disabled: Primary disabled background color
 *
 * @prop --ads-button-background-color-secondary: Secondary background color
 * @prop --ads-button-background-color-secondary-focus: Secondary focused background color
 * @prop --ads-button-background-color-secondary-hover: Secondary hovered background color
 * @prop --ads-button-background-color-secondary-disabled: Secondary disabled background color

 * @prop --ads-button-background-color-tertiary: Tertiary background color
 * @prop --ads-button-background-color-tertiary-focus: Tertiary focused background color
 * @prop --ads-button-background-color-tertiary-hover: Tertiary hovered background color
 * @prop --ads-button-background-color-tertiary-disabled: Tertiary disabled background color
 *
 * @prop --ads-button-border-color-primary: Primary border color
 * @prop --ads-button-border-color-primary-disabled: Primary disabled border color
 * @prop --ads-button-border-color-primary-focus: Primary focused border color
 * @prop --ads-button-border-color-primary-hover: Primary hovered border color
 *
 * @prop --ads-button-border-color-secondary: Secondary border color
 * @prop --ads-button-border-color-secondary-disabled: Secondary disabled border color
 * @prop --ads-button-border-color-secondary-focus: Secondary focused border color
 * @prop --ads-button-border-color-secondary-hover: Secondary hovered border color
 *
 * @prop --ads-button-border-color-tertiary: Tertiary border color
 * @prop --ads-button-border-color-tertiary-disabled: Tertiary disabled border color
 * @prop --ads-button-border-color-tertiary-focus: Tertiary focused border color
 * @prop --ads-button-border-color-tertiary-hover: Tertiary hovered border color
 *
 * @prop --ads-button-color-primary: Primary text color
 * @prop --ads-button-color-primary-disabled: Primary disabled text color
 * @prop --ads-button-color-primary-focus: Primary focused text color
 * @prop --ads-button-color-primary-hover: Primary hovered text color
 *
 * @prop --ads-button-color-secondary: Secondary text color
 * @prop --ads-button-color-secondary-disabled: Secondary disabled text color
 * @prop --ads-button-color-secondary-focus: Secondary focused text color
 * @prop --ads-button-color-secondary-hover: Secondary hovered text color
 *
 * @prop --ads-button-color-tertiary: Secondary text color
 * @prop --ads-button-color-tertiary-disabled: Secondary disabled text color
 * @prop --ads-button-color-tertiary-focus: Secondary focused text color
 * @prop --ads-button-color-tertiary-hover: Secondary hovered text color
 */

::slotted(*) {
  display: inline-block !important;
}

:host {
  display: inline-block;

  &[type='button'],
  &[type='reset'],
  &[type='submit'] {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
  }
}

:host([theme='default']) {
  @include ads-vars-component-button-default;
}

:host([theme='dark']) {
  @include ads-vars-component-button-dark;
}

button {
  display: inherit !important;
  @include ads-button;
  @include ads-button-tertiary;
  font-family: var(--ads-font-family);
  width: inherit;
}

button.is-primary {
  @include ads-button-primary;
}

button.is-secondary {
  @include ads-button-secondary;
}

button.is-tertiary {
  @include ads-button-tertiary;
}

button.is-medium {
  @include ads-button-medium;
}

button.is-small {
  @include ads-button-small;
}

button.is-circular {
  @include ads-button-circular;

  &.is-medium {
    @include ads-button-circular-medium;
  }

  &.is-small {
    @include ads-button-circular-small;
  }
}
